import React, { useContext, useState } from "react";
import { CartContext } from "./CartContext";
import "../css/checkout.css";
import productData from "../Datas/productData";
import { Link, useLocation } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";

const CURRENCY = "EUR";

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [address1, setAddress1] = useState("");
  const [contact, setContact] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [company, setCompany] = useState("");
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const { sub } = location.state || {};

  const getProductById = (id) =>
    productData.find((product) => product.id === id);

  const calculateTotal = () =>
    cartItems.reduce((total, item) => {
      const product = getProductById(item.id);
      if (!product) return total;
      return total + parseFloat(product.price.replace(/,/g, "")) * item.quantity;
    }, 0);

  const createOrderNumber = () => {
    const timestamp = Date.now().toString();
    const randomValues = new Uint32Array(2);

    if (window.crypto?.getRandomValues) {
      window.crypto.getRandomValues(randomValues);
    } else {
      randomValues[0] = Math.floor(Math.random() * 0xffffffff);
      randomValues[1] = Math.floor(Math.random() * 0xffffffff);
    }

    const randomPart = `${randomValues[0]}${randomValues[1]}`
      .padEnd(14, "0")
      .slice(0, 14);
    return `${timestamp}${randomPart}`;
  };

  const handlePlaceOrder = (event) => {
    event.preventDefault();
    const newErrors = {};

    if (!contact.trim()) newErrors.contact = "Enter an email address";
    else if (!/^\S+@\S+\.\S+$/.test(contact.trim())) {
      newErrors.contact = "Enter a valid email address";
    }
    if (!countryCode) newErrors.countryCode = "Select a country or region";
    if (!firstName.trim()) newErrors.firstName = "Enter a first name";
    if (!lastName.trim()) newErrors.lastName = "Enter a last name";
    if (!address.trim()) newErrors.address = "Enter an address";
    if (!city.trim()) newErrors.city = "Enter a city";
    if (!postalCode.trim()) newErrors.postalCode = "Enter a ZIP / postal code";
    if (cartItems.length === 0) newErrors.cart = "Your cart is empty";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const firstProduct = getProductById(cartItems[0].id);
    if (!firstProduct) {
      setErrors({ cart: "The first product in your cart is unavailable" });
      return;
    }

    const resultUrl = new URL("/payment", window.location.origin);
    const paymentUrl = new URL("/create_payment.php", window.location.origin);
    const successUrl = new URL(resultUrl);
    const cancelUrl = new URL(resultUrl);
    successUrl.searchParams.set("state", "success");
    cancelUrl.searchParams.set("state", "cancel");

    paymentUrl.searchParams.set("orderNo", createOrderNumber());
    paymentUrl.searchParams.set("amount", calculateTotal().toFixed(2));
    paymentUrl.searchParams.set("currency", CURRENCY);
    paymentUrl.searchParams.set("email", contact.trim());
    paymentUrl.searchParams.set("success_url", successUrl.toString());
    paymentUrl.searchParams.set("cancel_url", cancelUrl.toString());
    paymentUrl.searchParams.set("title", firstProduct.name);

    window.location.assign(paymentUrl.toString());
  };

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="main-containerCheck">
      <div className="check-custom-checkout-page">
        <div className="left">
          <div className="check-order-info">
            <form onSubmit={handlePlaceOrder} noValidate>
              <div className="form-group">
                <label htmlFor="contact">Contact</label>
                <input
                  type="email"
                  id="contact"
                  name="contact"
                  value={contact}
                  placeholder="Email address"
                  onChange={(event) => setContact(event.target.value)}
                  aria-invalid={Boolean(errors.contact)}
                />
                {errors.contact && <p className="error">{errors.contact}</p>}
              </div>

              <div className="form-group">
                <label>Delivery</label>
                <ReactFlagsSelect
                  selected={countryCode}
                  onSelect={setCountryCode}
                  className="check-select"
                />
                {errors.countryCode && (
                  <p className="error country-error">{errors.countryCode}</p>
                )}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={firstName}
                    placeholder="First name *"
                    onChange={(event) => setFirstName(event.target.value)}
                  />
                  {errors.firstName && <p className="error">{errors.firstName}</p>}
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={lastName}
                    placeholder="Last name *"
                    onChange={(event) => setLastName(event.target.value)}
                  />
                  {errors.lastName && <p className="error">{errors.lastName}</p>}
                </div>
              </div>

              <div className="form-group">
                <input
                  type="text"
                  id="company-name"
                  name="company-name"
                  value={company}
                  onChange={(event) => setCompany(event.target.value)}
                  placeholder="Company name (optional)"
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={address}
                  onChange={(event) => setAddress(event.target.value)}
                  placeholder="Address"
                />
                {errors.address && <p className="error">{errors.address}</p>}
              </div>

              <div className="form-group">
                <input
                  type="text"
                  id="address1"
                  name="address1"
                  value={address1}
                  onChange={(event) => setAddress1(event.target.value)}
                  placeholder="Apartment, suite, etc. (optional)"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={city}
                    placeholder="City"
                    onChange={(event) => setCity(event.target.value)}
                  />
                  {errors.city && <p className="error">{errors.city}</p>}
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    id="postalCode"
                    name="postalCode"
                    value={postalCode}
                    placeholder="Postal code"
                    onChange={(event) => setPostalCode(event.target.value)}
                  />
                  {errors.postalCode && <p className="error">{errors.postalCode}</p>}
                </div>
              </div>

              {errors.cart && <p className="checkout-error">{errors.cart}</p>}
              <button className="check-checkout-button" type="submit">
                Pay Now
              </button>
            </form>

            <p>
              <Link
                to="/returns"
                style={{ textDecoration: "underline" }}
                onClick={toTop}
              >
                Shipping &amp; Returns Info
              </Link>
            </p>
          </div>
        </div>

        {!sub && (
          <div className="right">
            <div className="check-order-summary">
              <div className="check-order-details">
                {cartItems.map((item, index) => {
                  const product = getProductById(item.id);
                  if (!product || !product.images) return null;
                  return (
                    <div
                      key={`${item.id}-${item.size}-${item.color}-${index}`}
                      className="check-cart-item"
                    >
                      <img src={product.images[0]} alt={product.name} />
                      <div className="pro--qty">
                        <div className="qty-inner">{item.quantity}</div>
                      </div>
                      <div className="check-item-details">
                        <h3>
                          {product.name}
                          {item.size && <><br />Size: {item.size}</>}
                          {item.color && <><br />Color: {item.color}</>}
                        </h3>
                      </div>
                      <p className="cal-single">€{product.price}</p>
                    </div>
                  );
                })}

                <div className="check-summary-details">
                  <table className="summary-details22">
                    <tbody className="sumTbody22">
                      <tr className="sumTr22">
                        <th className="subtotalTh22" style={{ fontSize: "24px" }}>
                          Total
                        </th>
                        <th className="subtotalTxt22">
                          €{calculateTotal().toFixed(2)}
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckOut;
